import { Skeleton } from "antd";

const ProductSkeleton = ({ count = 12 }) => {
    return (
        <div className="row gx-4 gy-3">
            {Array.from(Array(count).keys()).map((_, index) => (
                <div className="col-6 col-lg-2" key={index}>
                    <Skeleton.Node
                        active
                        className="w-100 rounded-4"
                        style={{
                            height: 350,
                        }}
                    >
                        <div className="d-none"></div>
                    </Skeleton.Node>
                </div>
            ))}
        </div>
    );
};

export default ProductSkeleton;
